"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modules = void 0;
var Modules;
(function (Modules) {
    Modules["FILE_MANAGEMENT"] = "file-management-service";
    Modules["HR"] = "hr-service";
    Modules["INVENTORY"] = "inventory-service";
    Modules["PARTNERS"] = "partners-service";
    Modules["PRODUCT_IMPLEMENTATION"] = "product-implementation-service";
    Modules["PRODUCTION"] = "production-service";
    Modules["PRODUCTS"] = "products-service";
    Modules["REQUEST_FOR_QUOTE"] = "request-for-quote-service";
    Modules["SALES_ORDER"] = "sales-order-service";
    Modules["SETUP"] = "setup-service";
    Modules["SHIPMENT"] = "shipment-service";
    Modules["USER_MANAGEMENT"] = "user-management";
    Modules["TRAVERSE_FRONTEND"] = "traverse-frontend";
})(Modules = exports.Modules || (exports.Modules = {}));
//# sourceMappingURL=modules.js.map